import { actions } from '../../utils/constants';

export const fetchCourses = () => ({
    type: actions.ASYNC_FETCH_COURSES,
});

export const fetchTypesTests = () => ({
    type: actions.ASYNC_FETCH_TYPE_TESTS,
});

export const fetchTestsByType = payload => ({
    type: actions.ASYNC_FETCH_TESTS_BY_TYPE,
    payload,
});

export const fetchTestByCourse = payload => ({
    type: actions.ASYNC_FETCH_TESTS_BY_COURSE,
    payload,
});

export const setSelectTestCreateCoruse = payload => ({
    type: actions.SET_SELECT_TESTS_CREATE_COURSE,
    payload,
});

export const asyncSelectTestCreateCoruse = payload => ({
    type: actions.ASYNC_SET_SELECT_TESTS_CREATE_COURSE,
    payload,
});


export const createCourse = course => ({
    type: actions.ASYNC_CREATE_COURSE,
    payload: { ...course },
});

export const deleteCourse = courseId => ({
    type: actions.ASYNC_DELETE_COURSE,
    payload: {
        courseId,
    },
});

export const asyncFetchCourseTemplateTests = ({ courseId }) => ({
    type: actions.ASYNC_FETCH_COURSE_TEMPLATE_TESTS,
    payload: {
        courseId,
    },
});



// WEBPACK FOOTER //
// ./src/components/courses/courses.actions.js